<template>
  <v-container>
    <v-list two-line subheader>
      <v-list-item :key="'__newlist__'" link @click="newList">
        <v-list-item-avatar>
          <v-icon class="grey lighten-1 white--text">mdi-plus</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>New list</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        v-for="item in allStudyLists"
        :key="item.title"
        :to="{ name: 'StudyListDetail', params: { id: item.id.toString() } }"
      >
        <v-list-item-avatar>
          <v-icon class="grey lighten-1 white--text">mdi-content-copy</v-icon>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title v-text="item.name"></v-list-item-title>
          <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action>
          <v-menu bottom left transition="slide-y-transition">
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click.stop.prevent>
                <v-icon color="grey lighten-1">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="displayEditStudyList(item)">
                <v-list-item-action>
                  <v-icon>mdi-pencil</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Edit</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="deleteStudyListConfirmation(item.id)">
                <v-list-item-action>
                  <v-icon>mdi-delete</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-list-item-action>
      </v-list-item>
    </v-list>
    <v-dialog v-model="showAddStudyListDialog" max-width="800px">
      <AddStudyList v-bind:onFinish="closeAddStudyListDialog" />
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AddStudyList from "@/components/AddStudyList.vue";

export default {
  name: "YourLists",

  data: () => ({
    showAddStudyListDialog: false
  }),

  computed: mapGetters(["allStudyLists"]),

  methods: {
    ...mapActions(["fetchStudyLists", "deleteStudyList"]),

    newList() {
      this.showAddStudyListDialog = true;
    },

    closeAddStudyListDialog() {
      this.showAddStudyListDialog = false;
    },

    deleteStudyListConfirmation(id) {
      if (confirm("Delete this list?")) {
        this.deleteStudyList(id);
      }
    }
  },

  created() {
    this.fetchStudyLists();
  },

  components: {
    AddStudyList
  }
};
</script>
